import { useNavigate } from "react-router-dom"
import useTargetStorage from "@/hooks/useTargetStorage"
import SupplierList from "features/storages/suppliers/supplierList"
import Callout from "components/callout/callout"
import { useTranslation } from "react-i18next"
import Section from "components/layout/section"
import RightSidebar from "components/sidebar/right/RightSidebar"
import Button from "components/inputs/button"
import { ReactComponent as AddIcon } from "assets/icons/add.svg"
import PageTitle from "features/navigation/pageTitle"
import useAccess from "@/hooks/useAccess"
import useSuppliers from "@/hooks/useSuppliers"
import useStorages from "@/hooks/useStorages"
import { paramGuardStorage } from "@/utils/paramGuard"
import { AccessRole, DeviceSize } from "@/types"
import IconButton from "@/components/buttons/iconButton"
import useWindowDimensions from "@/hooks/useWindowDimensions"
import { MainSheetHeaderActions } from "@/components/layout/layoutChrome"

const Suppliers = () => {

    const { t } = useTranslation()
    const navigate = useNavigate()
    const { displayIfSize } = useWindowDimensions()

    const { targetStorageDocId: storageId } = useTargetStorage()
    
    const { suppliersStatus } = useSuppliers({ storageId })
    const { 
        storage,
        storageStatus,
        isSuppliersEnabled
    } = useStorages({ storageId })
    
    const {
        limitToRoles
    } = useAccess({ storageId: storageId || '' })

    // Check params and declare safe ones to use in JSX
    if (!paramGuardStorage({storageId, storage, storageStatus, navigate})) {
        return <></>
    }
    const safeStorageId = storageId!;

    // Redirect if suppliers are disabled for this storage
    if (!isSuppliersEnabled()) {
        navigate(`/storage`);
        return <></>;
    }

    // Return the JSX.
    return (
        <>
            <PageTitle title={t('titleSuppliers')} />
            <MainSheetHeaderActions>
                { limitToRoles([AccessRole.OWNER, AccessRole.EDITOR]) && (
                    displayIfSize([DeviceSize.SM]) ?
                    <IconButton to={`/storages/${safeStorageId}/suppliers/create`} colorScheme="blue" className="visible md:invisible"><AddIcon /></IconButton> :
                    <Button wideOnMobile design="primary" to={`/storages/${safeStorageId}/suppliers/create`} className="invisible md:visible"><AddIcon /><span>{t(`buttonNewSupplier`)}</span></Button>
                )}
            </MainSheetHeaderActions>
            <Callout type="info" id={`supplier-page-info`}>{t('suppliersInfo')}</Callout>
            <Section padX={false}>
                <SupplierList storageId={safeStorageId} />
            </Section>
            <RightSidebar />
        </>
    )
}

export default Suppliers
